import React from 'react';

import "../../pages/SurveyStart.scss";

export default function PrivacyOption({ id, label, description, checked, onChange, disabled }) {
    return (
        <label htmlFor={id} className="privacy_card">
            <input type="checkbox" id={id} checked={checked} onChange={onChange} disabled={disabled} />
            <div className="details">
                <div className="icon">
                    <img src={`${process.env.PUBLIC_URL}/images/survey/${id}.png`} alt={label} />
                </div>
                <div className="content">
                    <div className="content_title">{label}</div>
                    <div className="content_desc">{description}</div>
                </div>
            </div>
            <div className="tick"></div>
        </label>
    );
}
